/**
 * Normalizes customer data for editing/form usage
 * Extracts fields from various formats and ensures consistent structure
 */
export const normalizeCustomer = (c) => {
  if (!c) return null;
  console.log("DEBUG - Input to normalizeCustomer:", c);

  const fullName = (c.customerName || "").trim();
  const nameParts = fullName ? fullName.split(" ") : [];
  const firstName = c.firstName || nameParts[0] || "";
  const lastName = c.lastName || nameParts.slice(1).join(" ") || "";

  const rawLocation = c.location || "";
  const pincodeMatch = rawLocation.match(/\b(\d{5,6})\b/);
  const extractedPincode = pincodeMatch ? pincodeMatch[1] : "";

  const cleanedLocation = rawLocation.replace(/\s*-\s*\d{5,6}\s*$/, "");
  const locationParts = cleanedLocation
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  const city = c.city || locationParts[0] || "";
  const district = c.district || (locationParts.length === 3 ? locationParts[1] : "");
  const state = c.state || (locationParts.length === 3 ? locationParts[2] : (locationParts.length === 2 ? locationParts[1] : ""));

  const rawAddress = c.address || "";
  const addressParts = rawAddress.split(",").map(p => p.trim()).filter(Boolean);
  const geoFields = [city.toLowerCase(), district.toLowerCase(), state.toLowerCase()].filter(Boolean);

  const uniqueAddressParts = addressParts.filter(part => {
    const p = part.toLowerCase().trim();
    if (geoFields.includes(p)) return false;
    if (p === extractedPincode) return false;
    return true;
  });

  const normalized = {
    ...c,
    _id: (c._id || c.id || "").toString(),
    customId: c.customId || "",
    firstName,
    lastName,
    phoneNumber: c.phoneNumber || (c.phone || "").toString().replace(/\D/g, "").slice(-10),
    email: c.email || "",
    addressLine1: c.addressLine1 || c.address1 || uniqueAddressParts[0] || "",
    addressLine2: c.addressLine2 || c.address2 || uniqueAddressParts[1] || "",
    city,
    district,
    state,
    pincode: c.pincode || c.pinCode || extractedPincode || "",
    officeLocation: c.officeLocation || "",
    referenceType: c.referenceType || "",
    referenceDetails: c.referenceDetails || "",
    propertyType: c.propertyType || c.SDRequirement || "",
    budget: c.budget || 0,
    notes: c.notes || "",
    preferredDate: c.preferredDate || "",
    alternativeMeetingDate: c.alternativeMeetingDate || "",
    attendedBy: c.attendedBy || "",
    /* Developer: Nithin | Date: 09-07-2026 | Changes: appointmentDate mapped in normalization for unified Schedule Appointment field */
    appointmentDate: c.appointmentDate || "",
    appointmentTime: "",
    assignedTo:
      (typeof c.telecaller === "object" ? c.telecaller?._id : c.telecaller) ||
      (typeof c.assignedTo === "object" ? c.assignedTo?._id : c.assignedTo) ||
      "",
    status: c.teleStatus || c.status || "new",
  };

  console.log("DEBUG - Normalized Customer:", normalized);
  return normalized;
};




